<app-icon class="text-32" [name]="icon"
  [ngClass]="{
    'text-32': radioButtonGroup.size === 'default',
    'text-24': radioButtonGroup.size === 'small'
  }">
</app-icon>
